import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children }) => {
  const layoutRef = useRef(null);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const headerEl = document.querySelector('.site-header');
      if (headerEl && layoutRef.current) {
        const height = headerEl.getBoundingClientRect().height;
        if (height > 0) {
          layoutRef.current.style.setProperty('--site-header-height', `${Math.ceil(height)}px`);
        }
      }
    };

    updateHeaderHeight();
    const headerEl = document.querySelector('.site-header');
    let resizeObserver;
    if (headerEl && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => updateHeaderHeight());
      resizeObserver.observe(headerEl);
    }
    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);

  return (
    <div className="layout" ref={layoutRef}>
      <Header />
      <main className="main-content">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
